import {
  ToggleButtonGroup,
  toggleButtonGroupClasses,
  ToggleButtonGroupProps,
  useTheme
} from "@mui/material";

export const StyledToggleButtonGroup = (props: ToggleButtonGroupProps) => {
  const theme = useTheme();

  return (
    <ToggleButtonGroup
      {...props}
      sx={{
        [`& .${toggleButtonGroupClasses.grouped}`]: {
          justifyContent: "flex-start",
          marginBottom: theme.spacing(1),
          border: 0,
          borderRadius: 0,
          backgrondColor: theme.palette.background.paper
        },
        [`& .${toggleButtonGroupClasses.middleButton},& .${toggleButtonGroupClasses.lastButton}`]: {
          marginTop: 0
        },
        ...props.sx // allows overrides
      }}
    />
  );
};
